import { ExtendedWarrantySettings } from "@redotech/redo-return-warranties-common/extended-warranty";
import { RedoAdminClient } from ".";

/**
 * POST /teams/:teamId/extended-warranty-settings
 */
export async function updateExtendedWarrantySettings(
  client: RedoAdminClient,
  {
    teamId,
    extendedWarrantySettings,
    sideImage,
    logo,
    signal,
  }: {
    teamId: string;
    extendedWarrantySettings: ExtendedWarrantySettings;
    sideImage?: string;
    logo?: string;
    signal?: AbortSignal;
  },
): Promise<void> {
  const response = await client.client.post(
    `teams/${encodeURIComponent(teamId)}/extended-warranty-settings`,
    { extendedWarrantySettings, sideImage, logo },
    { headers: client.authorization(), signal },
  );
  return response.data;
}
